import React from 'react';
import { 
  Video, 
  HelpCircle,
  ExternalLink,
  Info,
  ChevronRight
} from 'lucide-react';
import './Telemedicine.css';

const Telemedicine = () => {
  return (
    <div className="telemedicine-page">
      <div className="telemedicine-header">
        <h1>Configurar Opción de Agregar Google Meet en Turnos</h1>
      </div>

      <div className="tele-main-card card">
        <div className="google-meet-branding">
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Google_Meet_icon_%282020%29.svg/2491px-Google_Meet_icon_%282020%29.svg.png" 
            alt="Google Meet" 
            className="meet-logo-img"
          />
          <span className="meet-text-logo">Google Meet</span>
        </div>

        <div className="tele-description">
          <p>Este módulo es ideal para el otorgamiento de turnos en las agendas de Profesionales que realizan Consultas Virtuales.</p>
          <p>Es muy fácil de configurar y aún más fácil de utilizar: en cada turno que se otorga desde la sección AGENDAS DE TURNOS, podrá incluirse un Link de Meet, exclusivo del turno.</p>
        </div>

        <div className="tele-support-box">
          <p>Si tienes dudas para habilitar esta opción envíanos un un <a href="#">mensaje desde la sección Ayuda</a>, o mail a <a href="mailto:hola@gdt.com">hola@gdt.com</a> para coordinar un llamado y te ayudaremos con la configuración.</p>
        </div>

        <div className="tele-action-buttons">
          <button className="btn-info-blue">VER MÁS INFO</button>
          <button className="btn-instructivo">VER INSTRUCTIVO DE USO</button>
        </div>
      </div>

      <div className="tele-enable-section card">
        <h2>Habilitar / Deshabilitar opción de agregar link de meet en turnos</h2>
        <p className="status-note red">La opción ahora está deshabilitada</p>
        
        <div className="enable-controls">
          <button className="btn-enable-main">HABILITAR ESTA OPCIÓN</button>
        </div>
      </div>

      <div className="tele-footer-links">
        <div className="footer-link-item">
          <HelpCircle size={18} />
          <span>Preguntas Frecuentes sobre Telemedicina</span>
          <ChevronRight size={18} className="margin-left-auto" />
        </div>
      </div>
    </div>
  );
};

export default Telemedicine;
